/**
 * Lazy initialization module for ActiveReports
 * This ensures the license key is set before any ActiveReports functionality is used
 * and allows the library to be code-split into a separate bundle
 */

let licenseInitialized = false;

export const initializeActiveReports = async () => {
  if (licenseInitialized) {
    return;
  }

  // Dynamically import ActiveReports Core
  const { Core } = await import("@grapecity/activereports");
  
  // Set license key if available
  if (process.env.REACT_APP_ACTIVE_REPORT_LICENSE_KEY) {
    Core.setLicenseKey(process.env.REACT_APP_ACTIVE_REPORT_LICENSE_KEY);
  }
  
  licenseInitialized = true;
};

